<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="adaptationModal businessApplicationEdit"
      :title="salesForecast.pkId ? '编辑' : '新建'"
      width="1200px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="salesForecast"
        :rules="ruleValidate"
        :disabled="disabled"
        class="form"
        label-width="100px">
      <div class="editTitle">销售预测信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="预测编号">
            <el-input v-model="salesForecast.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="salesForecast.customerName" readonly placeholder="请选择客户" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="销售员" prop="salesPersonName">
            <el-input v-model="salesForecast.salesPersonName" placeholder="请选择商务" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商务专员" prop="belongCmp">
            <el-input v-model="salesForecast.businessPersonName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建人" prop="creatorName">
            <el-input v-model="salesForecast.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建时间" prop="creatTime">
            <el-input v-model="salesForecast.creatTime" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">预测明细</div>
      <div>
        <el-button style="float: left" type="primary" @click="$refs.selectMaterial.open(materialFilter)"> 添加物料</el-button>
      </div>
      <el-table
          :data="salesForecast.details"
          border
          stripe
          row-key="pkid"
          :expand-row-keys="expandRowKeys">
        <el-table-column type="index" align="center" label="#" width="45"/>
        <el-table-column prop="materialNo" label="物料编号" width="100" show-overflow-tooltip/>
        <el-table-column prop="materialName" label="物料名称" width="160" show-overflow-tooltip/>
        <el-table-column prop="specification" label="规格型号" width="160" show-overflow-tooltip/>
        <el-table-column align="center" prop="salesOrderPrice" label="销售订单价格" width="110">
          <template slot-scope="scope">
            {{ scope.row.salesOrderPrice != null ? scope.row.salesOrderPrice.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="earlierThreeMonthQty" label="M-3月出货量" width="90"/>
        <el-table-column align="center" prop="earlierTwoMonthQty" label="M-2出货量" width="90"/>
        <el-table-column align="center" prop="earlierOneMonthQty" label="M-1出货量" width="90"/>
        <el-table-column align="center" prop="beiKuQty" label="备库数量" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.beiKuQty" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="thisMonthQty" label="M预测量" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.thisMonthQty" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="laterOneMonthQty" label="M+1预测量" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.laterOneMonthQty" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="laterTwoMonthQty" label="M+2预测量" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.laterTwoMonthQty" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="laterThreeMonthQty" label="M+3预测量" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.laterThreeMonthQty" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="beiKuAmount" label="备库金额" width="100"/>
        <el-table-column align="center" prop="thisMonthAmount" label="M月金额" width="100"/>
        <el-table-column align="center" prop="laterOneMonthAmount" label="M+1金额" width="100"/>
        <el-table-column align="center" prop="laterTwoMonthAmount" label="M+2金额" width="100"/>
        <el-table-column align="center" prop="laterThreeMonthAmount" label="M+3金额" width="100"/>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="salesForecast.details.splice(scope.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <material-select ref="selectMaterial" @select="selectMaterial"/>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "../../information/Customer/CustomerSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    components: { CustomerSelect, MaterialSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        disabled: false,
        salesForecast: {
          billNo: "",
          pkId:0,
          customerNo:"",
          customerName:"",
          salesPersonName:"",
          businessPersonName:"",
          creatorName:"",
          creatTime:"",
          details:[],
        },
        payMethods: [],
        postList: [],
        expandRowKeys: [],
        ruleValidate: {
          // payMethod: {required: true, message: "请选择付款方式", trigger: "change"},
          // customerName: {required: true, message: "请选择客户", trigger: "change"},
          // reason: {required: true, message: "请输入申请理由", trigger: "blur"},
          // beginEndDate: {required: true, message: "请选择期限", trigger: "blur"},
          // packDeliveryFee: {required: true, message: "请输入包装和运输费用", trigger: "blur"},
          // contactPositionId: {required: true, message: "请选择联系人职位", trigger: "blur"},
        },
        materialFilter: {
          status: 10,//启用
          priceStatus: 30,//已通过
        },
      };
    },

    methods: {
      open(row, edit) {
        this.dialogVisible = true;
        this.disabled = !edit;
        this.$nextTick(() => {
          if (row) {
            this.getData(row.pkId);
          }
        });
      },

      // 获取详情
      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `salesForecasts/${pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.salesForecast = resp.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择客户
      selectCustomerName(row) {
        this.businessApplication.customerID = row.customerID;
        this.businessApplication.customerName = row.customerName;
        this.businessApplication.contact = row.contact;
        this.businessApplication.mobile = row.telephone;
        this.businessApplication.contactPositionId = row.positionId;
        this.businessApplication.payMethod = row.zterm;
      },


      // 添加物料
      selectMaterial(row) {
        console.log(row);
        var result = this.salesForecast.details.some((item) => item.materialNo === row.no);
        if (result) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.salesForecast.details.push({
          materialNo: row.no,
          materialName: row.name,
          specification: row.zmyxh,
          earlierThreeMonthQty :0,
          earlierTwoMonthQty :0,
          earlierOneMonthQty:0,
          thisMonthQty:0,
          laterOneMonthQty:0,
          laterTwoMonthQty:0,
          laterThreeMonthQty:0,
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 校验商务申请物料
            if (!this.salesForecast.details.length) {
              this.$confirm("请添加预测明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            } else {
              // let result = this.salesForecast.details.some((item) => !item.laterOneMonthQty);
              // if (result) {
              //   this.$confirm("请输入M+1预测量", "错误", {
              //     type: "error",
              //     showCancelButton: false,
              //   });
              //   return;
              // }
            }
            this.submitLoading = true;
            this.$http
              .put("basic", "salesForecasts", this.salesForecast)
              .then((resp) => {
                if (resp.success) {
                  this.$message.success("编辑成功");
                  this.$emit("save-success");
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

    },
  };
</script>

<style>
.businessApplicationEdit .inputCenter .el-input__inner {
  text-align: center;
}
</style>
